module.exports = __webpack_public_path__ + "static/zeta-97788ab364872a05d373461a3efedaea.jpg";